import { AbstractVersion33 } from './abstract-version33';

export abstract class AbstractDiscoverableVersion33 extends AbstractVersion33 {}
